import { render } from "./PartialStorageEntries.vue?vue&type=template&id=520e8ad4"
import script from "./PartialStorageEntries.vue?vue&type=script&lang=js"
export * from "./PartialStorageEntries.vue?vue&type=script&lang=js"

import "./PartialStorageEntries.vue?vue&type=style&index=0&id=520e8ad4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__